/* Importing the createSlice and createAsyncThunk functions from the reduxjs/toolkit library. */
import {
  // createAsyncThunk
  createSlice,
} from '@reduxjs/toolkit';

/* Setting the initial state of the reducer. */
const initialState = {
  time: '--:--:-- --',
  isAuthenticated: false,
  BearerToken: null,
};

/* Creating a slice of the redux store. */
const defaultSlice = createSlice({
  name: 'default',
  initialState,
  reducers: {
    /* Setting the time in the state. */
    setTime: (state) => {
      state.time = new Date().toLocaleTimeString('en-US');
    },
  },
});

/* Exporting the reducer function. */
export default defaultSlice.reducer;

/* Exporting the setTime action creator. */
export const { setTime } = defaultSlice.actions;
